import { useCallback } from "react";
import { useAuth } from "../context/AuthContext";
import {
  assignOldestApplication,
  copyApplication,
  deleteApplication,
} from "../services/Application";
import useApplicationList from "./useApplicationList";


import logger from "../utils/logger";
const useApplicationActions = (onRefresh) => {
  const { userId, accessToken } = useAuth();

  const handleCopy = useCallback(
    async (applicationId, newName) => {
      try {
        const newId = await copyApplication(
          applicationId,
          userId,
          newName,
          accessToken
        );

        if (newId) {
          logger.log("[useApplicationActions] Kopia utworzona:", newId);
          if (onRefresh) onRefresh(); // Refresh list
          return newId;
        } else {
          throw new Error("Błąd podczas tworzenia kopii");
        }
      } catch (error) {
        logger.error("[useApplicationActions] Copy error:", error);
        throw error;
      }
    },
    [userId, accessToken, onRefresh]
  );

  const handleDelete = useCallback(
    async (applicationId) => {
      try {
        await deleteApplication(applicationId, userId, accessToken);
        logger.log(
          "[useApplicationActions] Aplikacja usunięta:",
          applicationId
        );
        if (onRefresh) onRefresh(); // Refresh list
      } catch (error) {
        logger.error("[useApplicationActions] Delete error:", error);
        throw error;
      }
    },
    [userId, accessToken, onRefresh]
  );

  const handleAssign = useCallback(async () => {
    try {
      const result = await assignOldestApplication(userId, accessToken);

      if (result !== "false") {
        logger.log("[useApplicationActions] Aplikacja przypisana:", result);
        if (onRefresh) onRefresh();
        return result;
      } else {
        throw new Error("Błąd podczas przypisywania");
      }
    } catch (error) {
      logger.error("[useApplicationActions] Assign error:", error);
      throw error;
    }
  }, [userId, accessToken, onRefresh]);

  return {
    handleCopy,
    handleDelete,
    handleAssign,
  };
};

export default useApplicationActions;


